export default __webpack_public_path__ + "static/media/Moonoz.21824f1e.svg";